"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorCircleBoldIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var ErrorCircleBold = function ErrorCircleBold(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M12 13.92a1 1 0 00-1 1 1 1 0 001 1 1 1 0 00.69-.3 1 1 0 00.26-.71 1 1 0 00-.95-.99z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M12 0a12 12 0 1012 12A12 12 0 0012 0zm7.26 12.92l-6.33 6.33a1.32 1.32 0 01-1.87 0l-6.34-6.33a1.33 1.33 0 010-1.87l6.33-6.33a1.33 1.33 0 011.87 0l6.33 6.33a1.33 1.33 0 01.39.94 1.31 1.31 0 01-.39.93z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M12 12.92a.65.65 0 00.66-.66v-4a.66.66 0 10-1.32 0v4a.66.66 0 00.66.66z"
  }));
};
ErrorCircleBold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.98 23.98"
};
const ErrorCircleBoldIcon = exports.ErrorCircleBoldIcon = (0, _createIconComponent.default)(ErrorCircleBold, 'ErrorCircleBold');